function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("polyline", {
  className: "checkmark-path_svg__checkmark-path_svg__st0",
  points: "1.5,7.7 6.1,11.5 15.5,1.6 ",
  fill: "none",
  strokeWidth: "3px",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
});

function SvgCheckmarkPath(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 17 13",
    style: {
      enableBackground: "new 0 0 17 13"
    },
    xmlSpace: "preserve"
  }, props), _ref);
}

export default SvgCheckmarkPath;